"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compressedTransactionsTableConf = exports.transactionsTableConf = void 0;
var date_fns_1 = require("date-fns");
var constants_1 = require("containers/TableMaker/constants");
var Amount_1 = __importDefault(require("./CellComponents/Amount"));
var Currency_1 = __importDefault(require("./CellComponents/Currency"));
var Source_1 = __importDefault(require("./CellComponents/Source"));
var UnlinkTransactionBtn_1 = __importDefault(require("./CellComponents/UnlinkTransactionBtn"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
exports.transactionsTableConf = {
    headersMap: {
        contactName: 'Vendor',
        reference: 'Description',
    },
    headerTooltip: {
        date: { list: ['Fully Paid On Date or Date (Xero)', 'Transaction Date (QuickBooks)', 'Payment Date (FinancialForce)'] },
        contactName: { list: ['Contact Name (Xero)', 'Vendor Name (QuickBooks)', 'Account Name (FinancialForce)'] },
        reference: {
            list: ['Reference (Xero Bank Transactions)', 'Private Note (Quickbooks)', 'Line Item Description (Invoices or Bills)'],
        },
        amount: {
            description: '**Amount** is tax exclusive and in base currency:',
            list: ['Line Amount (Line Items)', 'Sub-total (Xero)', 'Total Amount (QuickBooks)', 'Net Total (FinancialForce)'],
        },
        source: {
            description: '**Source** combines',
            list: ['Accounting Platform', 'Transaction Type', 'Attachments (if available)'],
        },
    },
    row: {
        isTitle: false,
    },
    extractors: {
        date: function (transaction) { return (0, date_fns_1.format)(transaction.date.toDate(), 'yyyy-MM-dd'); },
    },
    cells: [
        { field: 'date', cell: { width: MD } },
        { fields: ['contactName', 'reference'], cell: { width: XL + XS, growCell: true } },
        { field: 'amount', cell: { width: MD, textAlign: 'right' }, defaultOrder: -1, renderComponent: Amount_1.default },
        { field: 'currency', cell: { width: SM, textAlign: 'left' }, renderComponent: Currency_1.default, noSort: true },
        { field: 'source', cell: { width: MD, textAlign: 'right', growCell: true }, renderComponent: Source_1.default },
        {
            key: 'hideTransaction',
            cell: { width: 40, textAlign: 'center', isActionCell: true, isFlexCenter: true },
            renderComponent: UnlinkTransactionBtn_1.default,
            showOnHover: true,
        },
    ],
};
exports.compressedTransactionsTableConf = __assign(__assign({}, exports.transactionsTableConf), { row: {
        isTitle: false,
        sizing: 'compact',
    }, cells: [
        { field: 'date', cell: { width: MD } },
        { fields: ['contactName', 'reference'], cell: { width: LG, growCell: true } },
        { field: 'amount', cell: { width: MD, textAlign: 'right' }, defaultOrder: -1, renderComponent: Amount_1.default },
        { field: 'currency', cell: { width: SM, textAlign: 'left' }, renderComponent: Currency_1.default, noSort: true },
        { field: 'source', cell: { width: MD + 18, textAlign: 'right' }, renderComponent: Source_1.default },
        {
            key: 'hideTransaction',
            cell: { width: 40, textAlign: 'center', isActionCell: true, isFlexCenter: true },
            renderComponent: UnlinkTransactionBtn_1.default,
            showOnHover: true,
        },
    ] });
